import { usePrismItemStore } from 'stores/usePrismItemStore';

const SERVICE_UNAVAILABLE =
  'Service Unavailable, please refresh the page and try again.';

function buildMobileUploadURL() {
  const { qrLinkedMobileUploader } = window;
  const prismItem = usePrismItemStore.getState().prismItem;

  const uploaderConfigPath =
    qrLinkedMobileUploader?.desktopUploaderConfigPath || '';

  if (prismItem?.id && prismItem?.sec) {
    const params = new URLSearchParams({
      prism_id: prismItem.id,
      sec: prismItem.sec,
    });

    return `${uploaderConfigPath}?${params}`;
  }

  return uploaderConfigPath;
}

export async function fetchDesktopUploaderConfig() {
  try {
    const response = await fetch(buildMobileUploadURL());

    if (response.ok) {
      return await response.json();
    }

    return { error: SERVICE_UNAVAILABLE };
  } catch {
    // A network failure rejects with an Error object, which React cannot
    // render as the message.
    return { error: SERVICE_UNAVAILABLE };
  }
}
